import { render } from "./backendNotificationVillageTripBooked.vue?vue&type=template&id=5522ac38&ts=true"
import script from "./backendNotificationVillageTripBooked.vue?vue&type=script&lang=ts"
export * from "./backendNotificationVillageTripBooked.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__